import apiService from "./apiService"

const paymentMethodService = {
    getAvailablePaymentMethods: async () => {
        return await apiService.get("/PaymentMethod");
    }
}
export default paymentMethodService;